import React, { useState } from 'react';
import { Eye, LogOut, Loader2 } from 'lucide-react';
import axios from 'axios';
import { API } from '@/App';

/**
 * Sits across the top of every page while an admin is inside someone's account.
 *
 * Loud on purpose. There is no way to forget whose shop you are standing in, and Exit is
 * always one click away — the admin's own session was kept aside, never replaced.
 */
export const ViewAsBanner = () => {
  const raw = localStorage.getItem('view_as');
  const [leaving, setLeaving] = useState(false);
  if (!raw) return null;

  let session;
  try { session = JSON.parse(raw); } catch { return null; }

  const exit = async () => {
    setLeaving(true);
    try {
      await axios.post(`${API}/view-as/end`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
    } catch { /* leaving must work even if that call fails */ }
    const adminToken = localStorage.getItem('admin_token');
    const adminUser = localStorage.getItem('admin_user');
    if (adminToken) localStorage.setItem('token', adminToken);
    if (adminUser) localStorage.setItem('user', adminUser);
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    localStorage.removeItem('view_as');
    localStorage.removeItem('activeVendorId');
    window.location.href = '/dashboard/admin';
  };

  return (
    <div
      data-testid="view-as-banner"
      style={{
        position: 'sticky', top: 0, zIndex: 9999,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        gap: 14, flexWrap: 'wrap',
        padding: '10px 18px',
        background: 'linear-gradient(90deg, #7a3e12, #a1521a)',
        color: '#fff',
        fontFamily: "'Nunito Sans', sans-serif",
        fontSize: 13,
        boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
      }}
    >
      <Eye size={15} style={{ flexShrink: 0 }} />
      <span>
        You are looking at <strong data-testid="view-as-banner-name">{session.name}</strong>&apos;s
        account with their permission. Payouts, bank details, passwords and refunds are refused
        here.
      </span>
      <button
        onClick={exit}
        disabled={leaving}
        data-testid="view-as-exit-btn"
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          background: 'rgba(255,255,255,0.16)',
          border: '1px solid rgba(255,255,255,0.5)',
          color: '#fff', borderRadius: 999, padding: '5px 14px',
          fontFamily: 'inherit', fontSize: 12, fontWeight: 700, cursor: 'pointer',
          transition: 'background-color 160ms ease',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.28)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.16)'; }}
      >
        {leaving ? <Loader2 size={12} className="animate-spin" /> : <LogOut size={12} />}
        Exit
      </button>
    </div>
  );
};

export default ViewAsBanner;
